import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {amCharts_v4_category_line_template} from "./amCharts_v4_category_line_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {amCharts_v4_stacked_area_chart} from "./amCharts_v4_stacked_area_chart";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;


export interface Transaction {
    amount: string;
    date: string;
    identifier: string;
    name: string;
    type: string;
    isReversal: boolean;
}

export interface Entry {
    header: string;
    total: string;
    transactions: Array<Transaction>
}

export interface PendingTransactions {
    header: string;
    total: string;
    entries: Array<Entry>
}

enum ChartPanels {
    CUMULATIVE_EARNING = 'cumulativeEarning',
    TOP_FIVE_ARTICLES = 'topFiveArticles',
    DAILY_PAYMENT = 'dailyPayment',
}

export class usersProfilePayment_template extends vnTemplate {

    protected transactionsPagination: pagination_template;
    protected transactionsBrandFilter : multipleSelector_template;
    protected paymentPeriodFilter: filterDropdown_template;
    protected yearSelector: filterDropdown_template;

    // tooltips:
    protected periodFilterTooltip: infoButton_template;
    protected pendingTransactionsTooltip: infoButton_template;


    protected getTemplateHtml(): string {

        return `
            <div data-bind="visible: visible">
                <div class="sub-header w-justify">
                    <div class="w-left">
                        <div> ${ this.transactionsBrandFilter.getHtmlBuild() } </div>
                        <div style="display: flex;align-items: flex-start">
                            <div>
                                <div class="form-label form-label-box" style="z-index: 0">Period</div>
                                ${ this.paymentPeriodFilter.getHtmlBuild() }
                            </div>                            
                            <div class="w-tooltips-adv pos-top short" style="transform: translate(1rem,8px)">
                                ${ this.periodFilterTooltip.getHtmlBuild() }
                            </div>
                            
                        </div>
                        
                    </div>
                </div> 
                 <div class="w-filters-selected">
                    <div id="filters-selected" class="filters-selected">
                       <div id="selected-brands"></div>
                       <div id="selected-payments"></div>
                    </div>
                </div>
                
                <!-- Payments -->
                <div class="d-payment-grid" id="w-payment">
                    
                    <article class="user-dashboard" id="payment-slips" data-bind="css: { loading: isLoading }">
                        <div class="d-header">
                            <div class="d-header-title">
                                <i class="fal fa-file-invoice-dollar"></i>
                                <div>
                                    <div class="d-section">Payment slips</div>
                                </div>
                            </div>
                            <div class="d-header-filters">
                                <div class="d-header-pagination">
                                    ` + this.yearSelector.getHtmlBuild() + `
                                </div>
                            </div>
                        </div>
                        
                     
                       <table class="list-action"  data-bind="foreach: slips" class="d-content d-payment-slip">
                            <tr>
                                <td><a class="p-icon active" data-bind="attr: { href: detailUrl }"><span class="icon i-slip-print" data-bind="text: paymentDate"></span></a></td>
                                <td><a class="p-icon active" data-bind="attr: { href: detailUrl }"><button  type="button" data-bind="event: { click: $parent.onClickPrint }" class="icon i-file-pdf"></button></a></td>
                                <td><a class="p-icon active" data-bind="attr: { href: detailUrl }"><span class="amount" data-bind="text: symbol + amountDollars" ></span><sup data-bind="text: amountCents"></sup></a></td>
                            </tr>
                        </table>
                        
                    </article>
                    
                    <article class="user-dashboard" id="payment-pending" data-bind="css: { loading: isLoading }">
                        <div class="d-header">
                            <div class="d-header-title">
                                <i class="fal fa-piggy-bank"></i>
                                <div>
                                    <div class="d-section">Pending Transactions</div>
                                    <div  data-bind="text: 'Next Payment Date: ' + nextPayDate()" class="d-legend"></div>
                                </div>
                                    <div class="w-tooltips-adv pos-top short">
                                    ${this.pendingTransactionsTooltip.getHtmlBuild() }
                                </div>
                            </div>
                            
                            <div class="d-header-filters" style="display: flex;align-items: center;">
                                
                                <div class="d-footer d-payment-pending">Total Pendings: <span data-bind="text: transactionsTotalAmount"></span></div>
                                <div class="d-header-pagination"> ${ this.transactionsPagination.getHtmlBuild() } </div>
                            </div>
                        </div>
                        
                        <ul class="tran-brand-list">
                        
                            <li class="tran-brand-item" data-bind="foreach: transactions">
                            
                                <div class="row">
                                    <!-- ko if: $parent.brands() &&  $parent.brands()[$data.brand] -->
                                    <span class="brand full-width dark full-icon" data-bind="text: brand, css: $parent.brands()[$data.brand].iconImage"></span>
                                    <!-- /ko -->
                                    <strong class="brand" data-bind="text: brand + ' Total Pending: ' + '&nbsp;'"></strong>
                                    <strong><span class="amount" data-bind="text: $data.total"></span></strong>
                                </div>
                                
                                <ul class="tran-main-list" data-bind="foreach: $data.entries">
                                
                                    <li class="tran-main-item">
                                        <div class="row">
                                            <div class="full-width">
                                                <button class="expandable-btn icon i-dropdown-simple" data-bind="event: { click: $parents[1].onToggleTransactionEntry }"><span></span></button>
                                                <span class="main icon i-article-regular" data-bind="text: $data.header"></span>
                                            </div>
                                            <span class="amount" data-bind="text: $data.total"></span>
                                        </div>
                                        
                                        <div class="expandable">
                                            <ul class="tran-detail-list" data-bind="foreach: $data.transactions">
                                            
                                                <li class="tran-detail-item">
                                                    <div class="row">
                                                        <span class="icon tran-num performance" data-bind="text: $data.identifier, class: type"></span>
                                                        <span class="full-width tran-name" data-bind="text: $data.name"></span>
                                                        <span class="tran-date" data-bind="text: $data.date"></span>
                                                    </div> 
                                                    <span class="amount" data-bind="text: $data.amount"></span>   
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </article>
                </div>
            </div>           
            `;
    }

    protected initPartial(): void {

        this.transactionsPagination = new pagination_template("transactions_pagination", this.getTemplateViewModel(), this.caller);
        this.transactionsPagination.getTemplateViewModel().itemPerPage = 25;

        this.yearSelector = new filterDropdown_template('slips_selector', this.getTemplateViewModel(), this.caller);
        this.yearSelector.setLabel('Year');

        this.transactionsBrandFilter = new multipleSelector_template("transactions_brandFilter", this.getTemplateViewModel(), this.caller);
        this.transactionsBrandFilter.setLabel("Brands");
        this.transactionsBrandFilter.setFilterContainerClass('margin-neg');
        this.transactionsBrandFilter.setTagContainerId('selected-brands');
        this.transactionsBrandFilter.setTagContainerCaption('Selected Brands:');

        this.paymentPeriodFilter = new filterDropdown_template("transactions_paymentPeriodFilter", this.getTemplateViewModel(), this.caller);
        this.paymentPeriodFilter.setLabel("Payments");

        // tooltips sections
        this.buildAndSetTooltips();
    }

    private buildAndSetTooltips(): void {

        this.buildPeriodFilterTooltip();
        this.buildPendingTransactionsTooltip();
    }

    private buildPeriodFilterTooltip() {

        this.periodFilterTooltip = new infoButton_template('periodFilterTooltip', this.getTemplateViewModel(), this.caller);
        this.periodFilterTooltip.setTitle('Period Filter');
        this.periodFilterTooltip.setContent(
            `
            <p>Filters the transactions that will be displayed in the graphs and table below. Period ranges can vary if this user is setup to be paid twice per month (i.e. ranges of ~15 days) or once per month (i.e. ranges of ~30 days):</p>
            <ul>
                <li>Previous: Transactions that were paid out on the latest pay day</li>
                <li>Current: All pending transactions that are scheduled on or before the upcoming pay period close</li>
                <li>Next: All pending transactions that are scheduled after the upcoming pay period close and before the start of the subsequent period.
                <li>All: All transactions included in the above three periods (i.e. this does not mean all transactions in this user’s entire lifetime)</li>
            </ul>`
        );
    }


    private buildPendingTransactionsTooltip() {
        this.pendingTransactionsTooltip = new infoButton_template('pendingTransactionsTooltip', this.getTemplateViewModel(), this.caller);
        this.pendingTransactionsTooltip.setTitle('Pending Transactions');
        this.pendingTransactionsTooltip.setContent(
            `
            <p>Lists all the pending transactions in the selected period and brand. Transactions are grouped into their associated item for which they are paid (e.g. Article or Time Period). Expanding the item will display the detailed list of associated transactions.</p>
            <ul>
                <li>Note: only pending transactions are displayed. If the selected period is “Previous”, nothing will display, since that period has been paid out.</li>
            </ul>`
        );
    }

    protected getTemplateName(): string {

        return "usersProfilePayment-template";
    }

    protected getMainElementType(): string {

        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return [""];
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            visible: ko.observable(false),
            hasData: ko.observable(false),
            isLoading: ko.observable(0),
            brands: ko.observable([]),
            isShowAllPending: ko.observable(false),
            nextPayDate: ko.observable(""),
            transactions: ko.observableArray([]),
            transactionsOrderBy: ko.observable("dateCreation"),
            transactionsOrderByDirection: ko.observable("DESC"),
            transactionsOrderByAndDirection: ko.observable("dateCreation_DESC"),
            slips: ko.observableArray([]),
            slipsOrderBy: ko.observable("paymentDate"),
            slipsOrderByDirection: ko.observable("DESC"),
            slipsOrderByAndDirection: ko.observable("paymentDate_DESC"),
            transactionsTotalAmount: ko.observable(null),
            showTotal: ko.observable(false),
            activeChartTab: ko.observable(ChartPanels.CUMULATIVE_EARNING),
            isPrint: ko.observable(true),
            currency: ko.observable(null),
            onClickTransactionReorder: (value, data, event) => {
                self.onClickTransactionReorder(value, data, event);
            },
            onClickViewSlip: (data, event) => {
                self.onClickViewSlip(data);
            },
            onClickPrint: (data, event) => {

                self.onClickPrint(data, event);
            },
            showAllPending:  (data) => {
                self.showAllPending()
                return true;
            },
            onToggleTransactionEntry: (data, evt) => {
                self.onToggleTransactionEntry(evt);
            },
            onClickTooltip: (data, event) => {
                self.onClickTooltip(event);
            }
        }
    }

    public getViewModelForRequest() {

        return {
            transactionsOrderBy: this.getTemplateViewModel().transactionsOrderBy,
            transactionsOrderByDirection: this.getTemplateViewModel().transactionsOrderByDirection,
            slipsOrderBy: this.getTemplateViewModel().slipsOrderBy,
            slipsOrderByDirection: this.getTemplateViewModel().slipsOrderByDirection,
            transactionsPagination: this.getTemplateViewModel().transactions_pagination,
            yearSelector: this.getTemplateViewModel().slips_selector,
            filters : {
                transactionsBrandFilter : this.getTemplateViewModel().transactions_brandFilter.selectedItems,
                periods : this.getTemplateViewModel().transactions_paymentPeriodFilter.selectedOption,
                showAllPending: this.getTemplateViewModel().isShowAllPending,
            },
        }
    }

    public setTransactions(transactions: Array<PendingTransactions>): void {

        let symbol = this.getUserCurrencySymbol();
        transactions.forEach((t) => {

            t['total'] = this.buildNumberWithSignAndCurrencySymbol(t.total, symbol);

            t.entries.forEach((e) => {

                e['total'] = this.buildNumberWithSignAndCurrencySymbol(e.total, symbol);

                e.transactions.forEach((ti) => {

                    ti['amount'] = this.buildNumberWithSignAndCurrencySymbol((ti.isReversal) ? Number(ti.amount) * -1 : Number(ti.amount), symbol);
               });
            });
        });

        this.getTemplateViewModel().transactions(transactions);
    }

    private buildNumberWithSignAndCurrencySymbol(number, symbol): string {

        let amount = Number(number);
        let sign = (amount < 0) ? '-' + symbol : symbol;

        return sign + Math.abs(amount).toLocaleString('en-EG', {minimumFractionDigits: 2});
    }

    private getUserCurrencySymbol() {
        let symbol = '$'
        let currency = this.getTemplateViewModel().currency();
        if (currency) {
            symbol = currency.symbol;
        }
        return symbol;
    }

    public setTransactionsTotalAmount(transactionsTotalAmount) {

        let symbol = this.getUserCurrencySymbol();

        this.getTemplateViewModel().transactionsTotalAmount(this.buildNumberWithSignAndCurrencySymbol(transactionsTotalAmount, symbol));
    }

    public setSlips(slips): void {

        let symbol = this.getUserCurrencySymbol()
        let data = [];
        for (let slip of slips) {

            slip.symbol = symbol;
            slip.amountDollars = parseInt(slip.amount);
            slip.amountCents = (slip.amount % 1);
            slip.amountCents = slip.amountCents.toFixed(2) * 100;
            slip.amountCents = slip.amountCents.toFixed(0);
            slip.amountCents = slip.amountCents.toString().padStart(2, '0');
            slip.detailUrl = this.buildSlipDetailUrls(slip.idUser, slip.paymentDate);
            data.push(slip);
        }

        this.getTemplateViewModel().slips(data);
    }

    public buildSlipDetailUrls(userId: number, datePaid: string, isPrint: boolean = false): string {

        let url = window.location.origin + '/payment/documents/slip/'+ userId + '?datePaid=' + datePaid;

        if (isPrint) {

            url += '&print=true';
        }

        return url;
    }

    public showAllPending() {

        let currValue = this.getTemplateViewModel().isShowAllPending();
        this.getTemplateViewModel().isShowAllPending(!currValue);
        this.caller.onShowAllPending();
        return true;
    }

    public onToggleTransactionEntry(evt): void {

        let parent = evt.target.parentElement;

        while (!parent.classList.contains('tran-main-item'))
            parent = parent.parentElement;

        if (parent.classList.contains('is-open')) {

            parent.classList.remove('is-open');
        } else {
            parent.classList.add('is-open');
        }
    }

    public onClickTooltip(event): void {
        event.stopPropagation();
    }

    public onClickTransactionReorder(value, data, event) {

        data.transactionsOrderBy(value);
        //if column has already been sorted, flip the direction
        if (data.transactionsOrderByAndDirection().includes(value)) {

            if (data.transactionsOrderByDirection() == "DESC") {

                data.transactionsOrderByDirection("ASC");
            } else {

                data.transactionsOrderByDirection("DESC");
            }
        } else {

            //default column sort direction
            data.transactionsOrderByDirection("DESC");
        }

        data.transactionsOrderByAndDirection(value + "_" + data.transactionsOrderByDirection());

        this.caller.transactionListReorder();
    }

    public onClickViewSlip(data) {

        this.caller.viewSlip(data.idUser, data.paymentDate);
    }

    public onClickPrint(data, event) {

        event.stopPropagation();

        let slipUrl = this.buildSlipDetailUrls(data.idUser, data.paymentDate, true);

        window.open(slipUrl);
    }


    public setBrandFilter(userBrands, company) {

        let brands = [];
        for (let brand of userBrands) {
            brands.push({id: brand.shortName, name: brand.name});
        }

        if (company) {

            brands.push({id: 'VN', name: company.name});
        }

        this.transactionsBrandFilter.setItems(brands);
    }

    public setNextPayDate(nextPayDate) {

        this.getTemplateViewModel().nextPayDate(nextPayDate);
    }

    public setShowTotal(showTotal) {

        this.getTemplateViewModel().showTotal(showTotal);
    }

    public setVisible(visible) {

        this.getTemplateViewModel().visible(visible);
    }

    public setHasData(hasData) {

        this.getTemplateViewModel().hasData(hasData);
    }

    public setBrands(brands){

        let b = [];

        for (let brand of brands) {

            b[brand.name] = brand;
        }
        b['Valnet'] = {id: 'VN', name: 'Valnet', iconImage: 'full-icon i-VN'};

        this.getTemplateViewModel().brands([]);
        this.getTemplateViewModel().brands(b);
    }

    public isLoading(loading){

        this.getTemplateViewModel().isLoading(loading);
    }


    public setPaymentPeriods(periods): void {

        this.paymentPeriodFilter.setOptions(periods);
    }

    public setCurrency(currency): void {

        this.getTemplateViewModel().currency(currency);
    }

    public setYearSelector(years):void {

        this.yearSelector.setOptions(years);
    }

    public setYearSelectorSelectedOption(year) {

        this.yearSelector.setSelectedOption(year);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/usersProfilePayment_template.ts